// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HzBxV","modal":"Modal_modal__RajTW","title":"Modal_title__oxdun","closeModalIcon":"Modal_closeModalIcon__PE3o1"};